import { useCallback, useState } from 'react';
import { NavPage } from '../../../services/NavService';
import { ChainClient } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { usePromise } from '../../EditorCommon/usePromise';
import { LoadSpinner } from '../../LoadSpinner';
import { AdminNav } from '../AdminNav/AdminNav';
import "./ChainEditor.scss"
import { SingleChainAdmin } from './SingleChainAdmin';


export function ChainEditor(props: {

}) {

    const [updateCount, setUpdateCount] = useState(0);
    const [selectedChainId, setSelectedChainId] = useState<number | undefined>(undefined);

    const chainClient = useClient(ChainClient);
    const chainResponse = usePromise(useCallback(async () => {
        const uc = updateCount;
        const response = await chainClient.getChains();
        return {
            chains: response.chains,
            updateCount: uc,
        };
    }, [updateCount, chainClient]));

    const selectedChain = chainResponse?.chains.find(c => c.id === selectedChainId);

    const chainItems = chainResponse?.chains.map(c => {
        const classes = ["list-group-item"];
        if (selectedChain?.id === c.id) {
            classes.push("active");
        }
        return (
            <li key={c.id}
                className={classes.join(' ')}
                onClick={() => setSelectedChainId(c.id)}
            >{c.name}</li>
        )
    });

    function onChange() {
        setUpdateCount(updateCount + 1);
    }

    const key = (selectedChain?.id ?? 'none') + "-" + chainResponse?.updateCount;

    return (
        <div className="editor chain-editor ext-editor no-right-menu">
            <AdminNav page={NavPage.Admin.Chain} />

            <div className="left-toolbox">
                {chainItems === undefined
                    ? <LoadSpinner />
                    : <ul className="list-group chain-list" > {chainItems} </ul>
                }

            </div>

            <div className="main-editor ">
                {selectedChain
                    ? <SingleChainAdmin
                        key={key}
                        chain={selectedChain}
                        onChange={onChange} />
                    : <span>←←Select a chain to edit</span>
                    }
            </div>
        </div>
    );
}
